import { memo } from 'react';
import { EmailIcon, PhoneIcon } from '@/shared/config/entity-icons';
import { copyToClipboard } from '@/shared/lib/clipboard';
import { formatPhone, phoneForCopy } from '@/shared/lib/phone';
import { cn } from '@/shared/lib/cn';
import { toast } from '@/shared/ui';
import styles from './TicketDetail.module.css';

const RequesterContactsBase: React.FC<{
  email?: string | null;
  phone?: string | null;
  className?: string;
}> = ({ email, phone, className }) => {
  if (!email && !phone) return null;
  const copy = async (text: string, done: string) => {
    if (await copyToClipboard(text)) toast.success(done);
    else toast.error('Не удалось скопировать');
  };
  return (
    <div className={cn(styles.contacts, className)}>
      {phone && (
        <button
          type="button"
          className={styles.contact}
          title="Скопировать номер"
          onClick={() => void copy(phoneForCopy(phone), 'Номер скопирован')}
        >
          <PhoneIcon size={13} aria-hidden className={styles.contactIcon} />
          <span className={styles.contactText}>{formatPhone(phone)}</span>
        </button>
      )}
      {email && (
        <button
          type="button"
          className={styles.contact}
          title="Скопировать почту"
          onClick={() => void copy(email, 'Почта скопирована')}
        >
          <EmailIcon size={13} aria-hidden className={styles.contactIcon} />
          <span className={styles.contactText}>{email}</span>
        </button>
      )}
    </div>
  );
};

export const RequesterContacts = memo(RequesterContactsBase);
